import {exerciseTypes} from '#/themes/classic-quiz/exerciseTypes'
import {type ThemePlugin} from '#/types/capsule'
import {EditorComponent} from './EditorComponent'
import {PlayerComponent} from './PlayerComponent'
import {settingsSchema} from './settingsSchema'

const liquidGlassTheme: ThemePlugin = {
  id: 'liquid-glass',
  name: 'Liquid Glass',
  version: '1.0.0',
  description: 'Thème Apple-style avec effets verre liquide et dégradés',
  previewColor: '#6d28d9',
  category: 'minimal' as const,
  exerciseTypes,
  settingsSchema,
  PlayerComponent: PlayerComponent,
  EditorComponent: EditorComponent,
  PreviewComponent: PlayerComponent,
}

export default liquidGlassTheme
